import ParsedDocumentsTable from './ParsedDocumentsTable.component';

export default ParsedDocumentsTable;
